const problemDetailsBaseUri = "https://glow.wisetechglobal.com/";

export const applicationProblemType = Object.freeze({
  databaseMismatchError: `${problemDetailsBaseUri}proxy/database-mismatch`,
});

export const dataImportProblemType = Object.freeze({
  badData: `${problemDetailsBaseUri}data-import/bad-data`,
  fileIsEmpty: `${problemDetailsBaseUri}data-import/file-is-empty`,
  fileIsEncrypted: `${problemDetailsBaseUri}data-import/file-is-encrypted`,
  fileIsInvalidExcel: `${problemDetailsBaseUri}data-import/file-is-invalid-excel`,
  fileHasInvalidExcelSheet: `${problemDetailsBaseUri}data-import/file-has-invalid-excel-sheet`,
  fileTooOld: `${problemDetailsBaseUri}data-import/file-too-old`,
  fileTypeNotSupported: `${problemDetailsBaseUri}data-import/file-type-not-supported`,
  invalidMappingTargetColumn: `${problemDetailsBaseUri}data-import/invalid-mapping-target-column`,
  missingContentError: `${problemDetailsBaseUri}data-import/missing-content-error`,
  missingSeparatorError: `${problemDetailsBaseUri}data-import/missing-separator-error`,
  strictOOXMLExcelFileNotSupported: `${problemDetailsBaseUri}data-import/strict-ooxml-excel-file-not-supported`,
});

export const resetUserPasswordProblemType = Object.freeze({
  missingUser: `${problemDetailsBaseUri}password-reset/missing-user`,
});
